import { useImpersonate } from './ImpersonateContext';
import type { SystemRole } from '../shared/types/api';

const ROLE_RANK: Record<SystemRole, number> = {
  USER: 0,
  ACCOUNT_MANAGER: 1,
  SUPER_USER: 2,
};

export interface RoleHelper {
  role: SystemRole;
  isSuperUser: boolean;
  isAccountManager: boolean;
  isAtLeast: (min: SystemRole) => boolean;
}

/**
 * Returns role-checking helpers derived from the effective account.
 * When impersonating, reflects the impersonated user's role.
 * Defaults to 'USER' if no account is loaded yet.
 */
export function useRole(): RoleHelper {
  const { effectiveAccount } = useImpersonate();
  const role: SystemRole = effectiveAccount?.systemRole ?? 'USER';

  return {
    role,
    isSuperUser: role === 'SUPER_USER',
    isAccountManager: role === 'ACCOUNT_MANAGER',
    isAtLeast: (min: SystemRole) => ROLE_RANK[role] >= ROLE_RANK[min],
  };
}
